// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"98df0d36","977":"07fa9575"}[chunkId] + ".chunk.js";
};